import { defineMessage } from 'services/localization';

export const messages = {
    shippingDetailsSection: defineMessage('shipping_details_1'),
    shipTo: defineMessage('ship_to'),
    shippingAddress: defineMessage('shipping_address'),
    shipDate: defineMessage('shipping_date'),
    shipMethod: defineMessage('shipping_method'),
    fob: defineMessage('fob'),
    trackingNumbers: defineMessage('tracking_numbers'),
};
